<script>
import { defineComponent, computed } from "vue"
import { useRoute } from 'vue-router'

export default defineComponent({
  props: ["href", "class"],
  
  name: "NavLink",
  setup(props) {

    const route = useRoute()
    const isCurrent = computed(() => {
      return route.path == props.href
    })
    const linkClass = computed(() => {
      return isCurrent.value ? props.class+' w--current' : props.class
    })

    return { linkClass, isCurrent }
  }
})
</script>

<template>
  <router-link :to="href" :aria-current="isCurrent ? 'page' : null" :class="linkClass"><slot></slot></router-link>  
</template>
